import { render } from "./page-dpp.vue?vue&type=template&id=f5d62df0"
import script from "./page-dpp-origin.js?vue&type=script&lang=js"
export * from "./page-dpp-origin.js?vue&type=script&lang=js"

import "./page-dpp.vue?vue&type=style&index=0&id=f5d62df0&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__